import React from 'react'
import { NavigationMenuLink } from '@/components/ui/navigation-menu'
import { cn } from '@/lib/utils'
import type { BlackBookItemProps } from '@/types/components'

export const BlackBookItem = React.forwardRef<React.ComponentRef<'a'>, BlackBookItemProps>(
  (
    { className, title, description, isActive, comingSoon, isExternal, onClick, t, ...props },
    ref,
  ) => {
    const externalProps = isExternal
      ? {
          target: '_blank',
          rel: 'noopener noreferrer',
        }
      : {}

    return (
      <div>
        <NavigationMenuLink asChild>
          <a
            ref={ref}
            role="button"
            className={cn(
              'block select-none rounded-md p-3 leading-none no-underline outline-none transition-colors',
              comingSoon
                ? 'opacity-75 cursor-not-allowed'
                : 'hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground cursor-pointer',
              isActive && 'bg-accent text-accent-foreground',
              className,
            )}
            onClick={onClick}
            {...externalProps}
            {...props}
          >
            <div className="font-semibold tracking-tight leading-none flex items-center gap-2">
              {title}
              {comingSoon && (
                <span className="inline-flex items-center px-2 py-1 text-[10px] font-bold text-white bg-primary rounded-full">
                  {t('navigation.coming_soon') || 'COMING SOON'}
                </span>
              )}
            </div>
            <p className="mt-2 line-clamp-2 text-sm leading-snug text-muted-foreground">
              {description}
            </p>
          </a>
        </NavigationMenuLink>
      </div>
    )
  },
)

BlackBookItem.displayName = 'BlackBookItem'
